// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__2wRjp","Dot":"Spinner_Dot__13Y_w"};